module.exports = __webpack_public_path__ + "static/img/308_TO8_2294_og.3cfb24f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/308_TO8_2294_og.jpg
// module id = 8yye
// module chunks = 0